import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Correct or update one bike's data
 * @primary Bike edit form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/bikes/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
